import { render } from "./search-template.vue?vue&type=template&id=486ac028&external"
import script from "./reviews-index.vue?vue&type=script&lang=js"
export * from "./reviews-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__